import { EventHomepage } from '@/types/homepage.types';
import { BrandliveEvent } from '@/types/projects.types';
import { Put } from '../helpers';

export function SaveProject(event: BrandliveEvent): Promise<{ homepage: EventHomepage }> {
  return Put({
    path: '/v3/admin/event',
    body: { event },
  });
}
